
import Swiper from 'swiper'
import React, { useState, useEffect } from 'react'

export default function FadeInFadeOut(props) {
  const [ifon, setIfon] = useState({
    fadeInFadeOut: null
  })

  useEffect(() => {
    const example = new Swiper('.FadeInFadeOut', {
      loop: true,
      autoplay: true,
      speed: props.playbackSpeed,
      effect: 'fade'

    })

    setIfon({
      ...ifon,
      fadeInFadeOut: example
    })

    return () => {
      example.destroy && example.destroy()
    }
  }, [])

  useEffect(() => {
    ifon.fadeInFadeOut && (ifon.fadeInFadeOut.params.speed = props.playbackSpeed)
  }, [props.playbackSpeed])

  return (<div className='FadeInFadeOut'>
    <div class='swiper-wrapper'>
      {props.ifon.image_id_list.map((item) => {
        return <div class='swiper-slide' key={item.id}>
          <img className='slide_img' src={item.src}></img>
        </div>
      })}

    </div>
  </div>)
}
console.log(React)
